import { render, staticRenderFns } from "./InvitationItem.vue?vue&type=template&id=690e045c&scoped=true&"
import script from "./InvitationItem.vue?vue&type=script&lang=js&"
export * from "./InvitationItem.vue?vue&type=script&lang=js&"
import style0 from "./InvitationItem.vue?vue&type=style&index=0&id=690e045c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690e045c",
  null
  
)

export default component.exports